// 履歴表示で利用するAccordionSummary
// アコーディオンを開いたときのborderのstyleとボタンのアイコンを共通化

import { AccordionSummary } from '@material-ui/core';
import { FC } from 'react';
import { useStyles } from './useStyles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export type Props = {
  children?: React.ReactNode;
};

export const HistoryDiffAccordionSummary: FC<Props> = props => {
  const { children } = props;
  const classes = useStyles();
  return (
    <AccordionSummary
      className={classes.borderStyle}
      expandIcon={<ExpandMoreIcon />}
    >
      {children}
    </AccordionSummary>
  );
};
